import React from "react";
import ProductCard from "src/components/molecules/ProductCard";

const TopProductSlider = ({ products }) => {
  return (
    <>
      <div className="w-full bg-white">
        <div className="text-light-gray font-bold pb-2 px-6">Top 5 Products</div>
        <div className="border-white rounded-lg overflow-hidden">
          <div className="flex flex-nowrap w-full overflow-x-auto">
            {products.map((data, index) => (
              <div
                key={`${data.title}-${index}`}
                className={`w-24 mr-3 pb-4 ${index === 0 ? "ml-6" : index === 4 ? "mr-6" : ""}`}>
                <ProductCard {...data} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TopProductSlider;
